import {
  switzerlandProgram,
} from './szwajcaria-koleja-przez-alpy.js'

const programs = {
  [switzerlandProgram.programKey]:
    switzerlandProgram,
}

export function getProgramByKey(programKey) {
  return programs[programKey] ?? null
}